"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAge = exports.getMaxDateOfBirth = void 0;
function getMaxDateOfBirth(age) {
    const maxDateOfBirthValue = new Date();
    maxDateOfBirthValue.setFullYear(new Date().getFullYear() - age);
    maxDateOfBirthValue.setHours(0, 0, 0, 0); // Prevents time on max date for DOB.
    return maxDateOfBirthValue.toISOString().split('T')[0];
}
exports.getMaxDateOfBirth = getMaxDateOfBirth;
/**
 * Helper to calculate the age from a date.
 */
function calculateAge(toDate, fromDate) {
    // Get the current date
    const currentDate = fromDate && fromDate > toDate ? fromDate : new Date();
    // Calculate the difference in years
    let age = currentDate.getFullYear() - toDate.getFullYear();
    // Adjust if the current date is before the birth date in the current year
    const isBeforeBirthdayThisYear = currentDate.getMonth() < toDate.getMonth() ||
        (currentDate.getMonth() === toDate.getMonth() && currentDate.getDate() < toDate.getDate());
    // no point in decrementing 0; this could happen if dates are in the same year
    if (isBeforeBirthdayThisYear && 0 < age) {
        age--;
    }
    return age;
}
exports.calculateAge = calculateAge;
//# sourceMappingURL=utils.js.map